import actions from '@/store/admin/actions';

const adminModule = {
  state: () => ({
    statuses: [],
  }),
  mutations: {
    GET_STATUSES_SUCCESS(state, payload) {
      state.statuses = payload;
    },
  },
  getters: {
    getStatusList(state) {
      return [...state.statuses].sort((a, c) => a.id - c.id);
    },
  },
  actions,
  namespaced: true,
};

export default adminModule;
